import { render, staticRenderFns } from "./InformeAuditoriaDetailView.vue?vue&type=template&id=6b02f34e&scoped=true&"
import script from "./InformeAuditoriaDetailView.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaDetailView.vue?vue&type=script&lang=js&"
import style0 from "./InformeAuditoriaDetailView.vue?vue&type=style&index=0&id=6b02f34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b02f34e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VContainer,
  VDialog,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VProgressCircular,
  VSpacer,
  VSwitch,
  VToolbar,
  VToolbarTitle,
  VTooltip,
})
